export default __webpack_public_path__ + "static/media/casus-assignment-img.7498e4b0.svg";